/*

    rpotesil: Configurable table component helps to utilize frequently used table operations like sorting, filtering columns or dealing with large amount of columns.


*/
import classNames from "classnames";
import * as React from "react";
import { useEffect, useRef, useState } from "react";

export interface ScrollTableProps {
    children: any;
    cssWrapper?: string;
}

export const ScrollTable = (props: ScrollTableProps) => {
    const tableRootDom = useRef(null);
    const tableScrollDom = useRef(null);
    const tableDom = useRef(null);
    const [needsScrolling, setNeedsScroling] = useState(false);
    const [leftScrollDisabled, setLeftScrollDisabled] = useState(true);
    const [rightScrollDisabled, setRightScrollDisabled] = useState(false);

    const onWindowResize = () => {
        const trstyle = tableRootDom.current.clientWidth;
        const tstyle = tableDom.current.clientWidth;
        setNeedsScroling(trstyle < tstyle ? true : false);
        onTableScroll();
    };

    const onTableScroll = () => {
        const scrollMax = tableScrollDom.current.scrollWidth - tableScrollDom.current.offsetWidth;
        const scrollLeft = tableScrollDom.current.scrollLeft;
        setRightScrollDisabled(scrollLeft >= scrollMax ? true : false);
        setLeftScrollDisabled(scrollLeft == 0 ? true : false);
    };

    const performScroll = (direction: string, startOrStop: string) => {
        tableScrollDom.current.scrollLeft += direction == "right" ? 100 : -100;
    };

    useEffect(() => {
        window.addEventListener("resize", onWindowResize);
        tableScrollDom.current.addEventListener("scroll", onTableScroll);
        onWindowResize();
        return function cleanup() {
            window.removeEventListener("resize", onWindowResize);
            tableScrollDom.current.removeEventListener("scroll", onTableScroll);
        };
    }, []);

    useEffect(() => {
        onWindowResize();
    }, [props.children]);

    return (
        <div
            ref={tableRootDom}
            className={classNames({
                "ctable-root": true,
                "needs-scrolling": needsScrolling,
                "is-scrollable": true,
            })}
        >
            <button
                className="ctable-scrollleft"
                title="Scroll table left"
                disabled={leftScrollDisabled}
                onClick={() => performScroll("left", "start")}
            >
                <span className="sr-only">Scroll the table left</span>
            </button>
            <div className="ctable-scrollpane" ref={tableScrollDom}>
                <table className={classNames(props.cssWrapper, "data-table")} ref={tableDom}>
                    {props.children}
                </table>
            </div>
            <button
                className="ctable-scrollright"
                title="Scroll table right"
                disabled={rightScrollDisabled}
                onClick={() => performScroll("right", "start")}
            >
                <span className="sr-only">Scroll the table right</span>
            </button>
        </div>
    );
};
